import React, { useState } from 'react';
import axios from 'axios';
import { Icon } from '../../components/icons';

const FileUpload: React.FC<{ onUpload: () => void }> = ({ onUpload }) => {
    const [file, setFile] = useState<File | null>(null);
    const [uploading, setUploading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const onFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files) {
            setFile(event.target.files[0] ?? null);
            setError(null);
        }
    };

    const onFileUpload = () => {
        if (file) {
            const formData = new FormData();
            formData.append('file', file);
            setUploading(true);
            setError(null);
            axios.post('/api/payments/upload', formData)
                .then(() => {
                    setFile(null);
                    onUpload();
                })
                .catch(() => setError('Nie udało się wgrać pliku. Sprawdź, czy to właściwy plik z wyciągiem, i spróbuj ponownie.'))
                .finally(() => setUploading(false));
        }
    };

    return (
        <div>
            <label className="file-drop">
                <Icon name="upload" size={28} />
                {file
                    ? <span className="file-name">{file.name}</span>
                    : <span>Wybierz plik z transakcjami</span>}
                <span className="small">{file ? 'Kliknij, aby wybrać inny plik' : 'Kliknij i wskaż plik na dysku'}</span>
                <input type="file" onChange={onFileChange} aria-label="Plik z transakcjami" />
            </label>
            {error && <div className="alert alert-danger mt-3 mb-0" role="alert">{error}</div>}
            <div className="d-grid mt-3">
                <button className="btn btn-primary" onClick={onFileUpload} disabled={!file || uploading}>
                    {uploading && <span className="spinner-border spinner-border-sm" aria-hidden="true" />}
                    {uploading ? 'Wgrywanie…' : 'Wgraj'}
                </button>
            </div>
        </div>
    );
};

export default FileUpload;
